var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockRi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 1.56025V4.4C9.625 4.78504 9.625 4.97755 9.69993 5.12462C9.76585 5.25398 9.87102 5.35915 10.0004 5.42507C10.1474 5.5 10.34 5.5 10.725 5.5H13.5647M13.75 6.8669V11.825C13.75 12.9801 13.75 13.5577 13.5252 13.9989C13.3275 14.3869 13.0119 14.7025 12.6239 14.9002C12.1827 15.125 11.6051 15.125 10.45 15.125H6.05C4.89489 15.125 4.31734 15.125 3.87614 14.9002C3.48806 14.7025 3.17254 14.3869 2.9748 13.9989C2.75 13.5577 2.75 12.9801 2.75 11.825V4.675C2.75 3.51989 2.75 2.94234 2.9748 2.50114C3.17254 2.11306 3.48806 1.79754 3.87614 1.5998C4.31734 1.375 4.89489 1.375 6.05 1.375H8.2581C8.76256 1.375 9.0148 1.375 9.25217 1.43199C9.46262 1.48251 9.6638 1.56585 9.84834 1.67893C10.0565 1.80648 10.2348 1.98483 10.5915 2.34155L12.7835 4.53345C13.1402 4.89017 13.3185 5.06852 13.4461 5.27666C13.5592 5.4612 13.6425 5.66238 13.693 5.87283C13.75 6.1102 13.75 6.36244 13.75 6.8669Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 14.3332C5.22325 13.3009 6.69362 12.4345 8.5 12.4999C10.2453 12.5631 11.5268 13.4676 12.5 14.4999M10.375 9.125C10.375 10.1605 9.53553 11 8.5 11C7.46447 11 6.625 10.1605 6.625 9.125C6.625 8.08947 7.46447 7.25 8.5 7.25C9.53553 7.25 10.375 8.08947 10.375 9.125Z",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_3980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockRi);
export default __webpack_public_path__ + "static/media/stockRI.1cded87e49523ab6afbbecddc38fee97.svg";
export { ForwardRef as ReactComponent };